
import { ContactAddress } from "@/models/base";
import { DocumentLayoutClientHeading } from "@/utils/documents/layout-client-heading";
import Vue from "vue";
import { ISelectItem } from "winfakt-vue-components";
import { StringStyledPropertyWithFreeLine } from "../../utils/documents/string-styled-property-with-free-line";
import AppStyleEditor from "./StyleEditor.vue";
import AppCustomLanguageSelect from "@/components/CustomLanguageSelect.vue";
import AppAllLayoutsSelect from "./AllLayoutsSelect.vue";
import { SaleLayoutInfo } from "@/utils/sale-layouts/sale-layout-info";
import { DocumentLayoutInfo } from "@/utils/documents/layout-info";
import { ReminderService, SaleService } from "@/services";

export default Vue.extend({
	data() {
		return {
			toEditStyleHeading: null as null | StringStyledPropertyWithFreeLine,
			toEditFreeLine: null as null | StringStyledPropertyWithFreeLine,
			freeLineText: "",
			clientHeadingItems: [] as StringStyledPropertyWithFreeLine[],
			allLayoutsSelectModalOpen: false
		};
	},
	props: {
		heading: {
			type: Object as () => DocumentLayoutClientHeading,
			required: true
		},
		lang: String,
		contactGroupId: Number,
		showResetButton: Boolean,
		isDeliveryAddress: Boolean
	},
	computed: {
		props():ISelectItem<string>[] {
			let result:ISelectItem<string>[] = ContactAddress.getMapFields(this.contactGroupId).map(l => {
				return {
					text: l.name,
					value: l.prop
				} as ISelectItem<string>;
			});

			result.unshift({
				text: this.$ct("free-line"),
				value: "FreeLine"
			});

			result.unshift({
				text: this.$ct("common.empty"),
				value: ""
			});
			return result;
		},
		buttonBarItems():ISelectItem<Function>[]{
			let result:ISelectItem<Function>[] = [
				{
					text: this.$ct("convert-to-free-block"),
					value: this.convertToFreeBlock,
					disabled: !this.heading.Show
				},
				{
					text: this.$ct("apply-heading-to-other-layouts"),
					value: this.openApplyToOtherLayoutsModal
				}
			] as ISelectItem<Function>[];
			if  (this.showResetButton) {
				result.push({
					text: this.$ct("reset-to-default"),
					value: this.resetToDefaultSettings
				});
			}
			return result;
		}
	},
	methods: {
		convertToFreeBlock(){
			this.$emit("convert-to-free-block");
		},
		editStyle(style: StringStyledPropertyWithFreeLine) {
			this.toEditStyleHeading = style;
		},
		editFreeLine(item:StringStyledPropertyWithFreeLine){
			this.toEditFreeLine = item;
			this.freeLineText = item.FreeLineText.getTranslation(this.lang);
		},
		setLang(lang:string){
			this.$emit("update:lang", lang);
		},
		confirmEditFreeLine(){
			if (!this.toEditFreeLine) return;
			this.toEditFreeLine.FreeLineText.Translations[this.lang] = this.freeLineText;
			this.toEditFreeLine = null;
		},
		onSorted(){
			this.heading.Property1 = this.clientHeadingItems[0];
			this.heading.Property2 = this.clientHeadingItems[1];
			this.heading.Property3 = this.clientHeadingItems[2];
			this.heading.Property4 = this.clientHeadingItems[3];
			this.heading.Property5 = this.clientHeadingItems[4];
			this.heading.Property6 = this.clientHeadingItems[5];
			this.heading.Property7 = this.clientHeadingItems[6];
			this.heading.Property8 = this.clientHeadingItems[7];
			this.heading.Property9 = this.clientHeadingItems[8];
		},
		resetToDefaultSettings(){
			this.$emit("reset-to-default");
		},
		openApplyToOtherLayoutsModal(){
			this.allLayoutsSelectModalOpen = true;
		},
		async applyHeadingToSaleLayouts(layouts:SaleLayoutInfo[]){
			await SaleService.applyClientHeadingToLayouts(layouts, this.heading);
		},
		async applyHeadingToReminderLayouts(layouts:DocumentLayoutInfo[]){
			await ReminderService.applyClientHeadingToLayouts(layouts, this.heading);
		},
		async applyHeadingToOtherLayoutsHandler(saleLayouts:SaleLayoutInfo[], reminderLayouts:DocumentLayoutInfo[]) {
			if (saleLayouts.length > 0){
				await this.applyHeadingToSaleLayouts(saleLayouts);
			}
			if (reminderLayouts.length > 0){
				await this.applyHeadingToReminderLayouts(reminderLayouts);
			}
			this.$wf.notify(this.$ct("common.success"), "success", 3000, "check");
			this.allLayoutsSelectModalOpen = false;
		}
	},
	mounted(){
		this.clientHeadingItems = [
			this.heading.Property1,
			this.heading.Property2,
			this.heading.Property3,
			this.heading.Property4,
			this.heading.Property5,
			this.heading.Property6,
			this.heading.Property7,
			this.heading.Property8,
			this.heading.Property9,
		];
	},
	components: {
		AppStyleEditor,
		AppCustomLanguageSelect,
		AppAllLayoutsSelect
	},
	i18nEx: {
		componentPrefix: "components.layout-editor"
	}
});
